/* app/js/src/components/calendar/expandable/calendar-expandable-new-sec-event/calendar-expandable-new-sec-event.component.scss */
.new-sec-event-container {
  width: 100%;
  height: 51px;
  margin-top: 9px;
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
}
.new-sec-event-container.visible {
  display: flex;
}
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 12px;
  font-weight: 400;
}
.video-camera-icon {
  display: flex;
  align-items: center;
}
.video-camera-icon ::ng-deep svg {
  width: 26.67px;
  height: 16px;
}
.drag-text {
  display: flex;
  align-items: center;
  margin-left: 17px;
}
.dashed-border {
  background-image:
    linear-gradient(
      to right,
      #7b90a4 50%,
      transparent 50%),
    linear-gradient(
      to right,
      #7b90a4 50%,
      transparent 50%),
    linear-gradient(
      to bottom,
      #7b90a4 50%,
      transparent 50%),
    linear-gradient(
      to bottom,
      #7b90a4 50%,
      transparent 50%);
  background-position:
    left top,
    left bottom,
    left top,
    right top;
  background-repeat:
    repeat-x,
    repeat-x,
    repeat-y,
    repeat-y;
  background-size:
    10px 1px,
    10px 1px,
    1px 10px,
    1px 10px;
}
.hover-border {
  border: 2px solid #2dbbfc;
  box-sizing: border-box;
}
/*# sourceMappingURL=calendar-expandable-new-sec-event.component.css.map */
